import { render, staticRenderFns } from "./ToggleButtons.vue?vue&type=template&id=0745dfd6&scoped=true&"
import script from "./ToggleButtons.vue?vue&type=script&lang=js&"
export * from "./ToggleButtons.vue?vue&type=script&lang=js&"
import style0 from "./ToggleButtons.vue?vue&type=style&index=0&id=0745dfd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0745dfd6",
  null
  
)

export default component.exports